/**
 * Console Filters - Production Console Noise Suppression
 *
 * Filters out known third-party upgrade messages and performance violations
 * that we cannot control. Only active in production builds.
 */

const SUPPRESSED_PATTERNS = [
  'IFRAME-RESIZER',
  'iframe-resizer',
  '[Violation]',
  'Violation:', // Chrome performance warnings
  'nytsys', // Nytsys analytics spam
  'ns :', // Nytsys namespace logs
  'Data loading failed', // Nytsys domain mismatch
  'You have already initialized PostHog', // PostHog duplicate init warning
  'anychat', // AnyChat widget errors
  'api.anychat.one', // AnyChat API errors
];

export function initializeConsoleFilters(): void {
  // Only filter in production
  if (import.meta.env.DEV) {
    return;
  }

  // Suppress console.warn for known third-party upgrade messages
  const originalWarn = console.warn;
  console.warn = function (...args: unknown[]) {
    const message = args[0]?.toString() || '';

    // Check if message matches any suppressed pattern
    if (SUPPRESSED_PATTERNS.some((pattern) => message.includes(pattern))) {
      return; // Suppress this message
    }

    // Pass through all other warnings
    originalWarn.apply(console, args);
  };

  // Suppress console.log for known third-party spam
  const originalLog = console.log;
  console.log = function (...args: unknown[]) {
    const message = args[0]?.toString() || '';

    // Check if message matches any suppressed pattern
    if (SUPPRESSED_PATTERNS.some((pattern) => message.includes(pattern))) {
      return; // Suppress this message
    }

    // Pass through all other logs
    originalLog.apply(console, args);
  };

  // Suppress console.error for known issues
  const originalError = console.error;
  console.error = function (...args: unknown[]) {
    const message = args[0]?.toString() || '';

    // Check if message matches any suppressed pattern
    if (SUPPRESSED_PATTERNS.some((pattern) => message.includes(pattern))) {
      return; // Suppress this message
    }

    // Pass through all other errors
    originalError.apply(console, args);
  };

  // Log that filters are active (only once)
  console.info('[SBI] Console filters active (production mode)');
}
